import React, { useEffect, useState } from "react";
import { Grid, Card, Image, Text, Button, Container, Box } from "@mantine/core";
import { SignatureTable } from "./SignatureTable";

// Utility function to split title into main title and subtitle
const splitTitle = (title: string) => {
  const match = title.match(/^(.*?)\s\((.*?)\)$/);
  return match ? { main: match[1], subtitle: match[2] } : { main: title, subtitle: "" };
};

const registryItems = [
  {
    title: "Indie's New Ride (Stroller Fund)",
    image: "https://nunababy.ca/common/sitemedia/lg-19436218-0.png",
    price: "$1,200",
    description: "A smooth, stylish stroller for Indie’s adventures in the world. Help us roll in comfort and safety!",
    link: "https://buy.stripe.com/fZe2bc1Gl54Sdnq3cc",
  },
  {
    title: "Car Safety Device (Carseat Fund)",
    image: "https://nunababy.ca/common/sitemedia/lg-19350614-6.png",
    price: "$38.99",
    description: "Ensure Indie travels safely with this must-have car safety device for every family road trip.",
    link: "https://buy.stripe.com/28oeXY1GldBo0AE6op",
  },
  {
    title: "The Baby Necessities (Diaper Fund)",
    image: "https://m.media-amazon.com/images/I/713wfcAeTmL.jpg",
    price: "$79.99",
    description: "Contribute to Indie’s diaper fund! Newborns go through 10–12 diapers daily, and every little bit helps.",
    link: "https://buy.stripe.com/fZebLMet740O3MQ3ce",
  },
  {
    title: "Amazon Gift Registry (Pick an Item)",
    image: "https://m.media-amazon.com/images/I/71EG0h8mFaL.jpg",
    price: "Any Amount",
    description: "A handful of extras we thought might come in handy along the way.",
    link: "https://www.amazon.ca/baby-reg/sarah-taggart-nicholas-hendrickson-march-2025-calgary/D2MO57Y9WH99",
  },
];

export const RegistryGrid = () => {
  return (
    <Container size="xl" my="xl" p={0}>
      <Grid gutter="lg" columns={12}>
        {registryItems.map((item, index) => {
          const { main, subtitle } = splitTitle(item.title);
          return (
            <Grid.Col key={index} span={{ base: 12, sm: 6, lg: 3 }}>
              <Card
                shadow="sm"
                p="lg"
                radius="md"
                withBorder
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                  minHeight: "400px",
                }}
              >
                <Card.Section>
                  <Image src={item.image} alt={main} height={200} fit="contain" />
                </Card.Section>

                <Box style={{ flex: 1 }}>
                  <Text fw={500} size="lg" mt="md" ta="center">
                    {main}
                  </Text>

                  {subtitle && (
                    <Text size="sm" c="dimmed" ta="center" mt="xs">
                      {subtitle}
                    </Text>
                  )}

                  {item.description && (
                    <Text size="sm" c="dimmed" mt="md" ta="center">
                      {item.description}
                    </Text>
                  )}
                </Box>

                <Button
                  component="a"
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  mt="md"
                  fullWidth
                  color="#7fac9d"
                >
                  Contribute ❤️
                </Button>
              </Card>
            </Grid.Col>
          );
        })}
      </Grid>
    </Container>
  );
};
